import styled from 'styled-components';

export const StepIndicatorContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 16px 4px;
  height: 52px;
  width: 178px;
  align-items: center;
  text-wrap-mode: nowrap;
  column-gap: 10px;

  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    padding-top: 24px;
  }
`;

export const AriaHideContainer = styled.div.attrs(() => ({
  'aria-hidden': 'true',
}))`
  display: contents;
`;
